import React from 'react';
import { useMatch, useNavigate } from 'react-router';
import { LOGIN_ROUTE, ROOT } from 'src/constants/routes';
import { useResponsive } from 'src/hooks/responsive';
import { useAppDispatch, useAppSelector } from 'src/hooks/store';
import { checkRedirectSignIn, me } from 'src/store/user/actions';
import { selectUserId } from 'src/store/user/selectors';

export default function AuthInit() {
  const appDispatch = useAppDispatch();
  const userId = useAppSelector(selectUserId);
  const [isMobile] = useResponsive(['MOBILE']);
  const navigate = useNavigate();

  const removePreloaderTimeoutRef = React.useRef<NodeJS.Timeout | number | null>(null);

  const match = useMatch(LOGIN_ROUTE);
  const isSignInRoute = match !== null;

  React.useEffect(() => {
    const checkSignIn = async () => {
      if (isMobile === undefined) {
        return;
      }

      const isCheckRedirectSignInRequired = window.localStorage.getItem('isCheckRedirectSignInRequired') === 'true';
      let isSignedInByRedirect = false;

      if (isCheckRedirectSignInRequired && isMobile && !userId) {
        isSignedInByRedirect = !!(await appDispatch(checkRedirectSignIn())).payload;
        window.localStorage.setItem('isCheckRedirectSignInRequired', 'false');

        if (isSignedInByRedirect && isSignInRoute) {
          navigate(ROOT);
        }
      }

      if (!isSignedInByRedirect && !userId) {
        const meResult = await appDispatch(me());

        if (meResult.meta.requestStatus === 'rejected') {
          console.log('Client is unauthorized...');
        } else {
          console.info('todo - getUserData');
          // appDispatch(getUserData({ target: 'all' }));
        }
      }
      // else if (!isSignedInByRedirect && userId) {
      // appDispatch(getUserData({ target: 'all' }));
      // }

      removeRootPreloader();
    };

    checkSignIn();
  }, [appDispatch, isMobile]);

  const removeRootPreloader = () => {
    const preloadingScreen: HTMLElement | null = document.querySelector('.main-preloader');

    if (preloadingScreen) {
      setTimeout(() => {
        preloadingScreen.style.opacity = '0';
        preloadingScreen.style.visibility = 'hidden';
        preloadingScreen.style.pointerEvents = 'none';
      }, 500);

      if (removePreloaderTimeoutRef.current) clearTimeout(removePreloaderTimeoutRef.current);
      removePreloaderTimeoutRef.current = setTimeout(() => {
        if (document && document.body) {
          document.body.removeChild(preloadingScreen);
        }
      }, 1500);
    }
  };

  return null;
}
